import {Component, Input, OnInit, ChangeDetectionStrategy} from '@angular/core';
import {App} from '../../../shared/models/app';
import {FileUploadService} from '../../../core/services/file-upload.service';
import {ImageCardComponent} from '../image-card/image-card.component';
import {RouterLink} from '@angular/router';

@Component({
  selector: 'motn-image-card-app',
  templateUrl: './image-card-app.component.html',
  styleUrls: ['./image-card-app.component.scss'],
  changeDetection: ChangeDetectionStrategy.Eager,
  imports: [
    ImageCardComponent,
    RouterLink,
  ],
})
export class ImageCardAppComponent implements OnInit {
  @Input() app: App;

  imgSource: string = '';
  href: string = '';

  constructor(
    private fileUploadService: FileUploadService,
  ) {
  }

  ngOnInit(): void {
    if (this.app.Image) {
      this.fileUploadService.fetch(this.app.Image).subscribe(
        (data) => {
          if (data) {
            this.imgSource = data.URL;
          }
        },
      );
    } else {
      this.imgSource = '../../../assets/img/splash-3x.png';
    }

    const rootUri = this.app.Type === 'picture' ? 'mosaic' : this.app.Type;

    this.href = `/${rootUri}/${this.app.ID}`;
  }
}
